/** Native scrolling within the page; no rubber band beyond either painted edge. */
export function scrollWouldOvershoot(scrollTop: number, scrollHeight: number, clientHeight: number, deltaY: number): boolean {
  const max = Math.max(0, scrollHeight - clientHeight);
  return max <= 1 || (scrollTop <= 0 && deltaY > 0) || (scrollTop >= max - 1 && deltaY < 0);
}
export function installScrollBoundaryGuard(page: HTMLElement, signal: AbortSignal): void {
  let last: { x: number; y: number; id: number } | null = null;
  page.addEventListener("touchstart", event => {
    const touch = event.touches.length === 1 ? event.touches[0] : undefined;
    last = touch ? { x: touch.clientX, y: touch.clientY, id: touch.identifier } : null;
  }, { passive: true, signal });
  page.addEventListener("touchmove", event => {
    const touch = event.touches.length === 1 ? event.touches[0] : undefined;
    if (!touch || touch.identifier !== last?.id) { last = null; return; }
    const dx = touch.clientX - last.x, dy = touch.clientY - last.y;
    last = { x: touch.clientX, y: touch.clientY, id: touch.identifier };
    // Do not consume horizontal sliders, text selection or multi-touch gestures.
    if (Math.abs(dy) <= Math.abs(dx)) return;
    if (scrollWouldOvershoot(page.scrollTop, page.scrollHeight, page.clientHeight, dy) && event.cancelable) event.preventDefault();
  }, { passive: false, signal });
  for (const type of ["touchend", "touchcancel"]) page.addEventListener(type, () => { last = null; }, { passive: true, signal });
}
